module.exports = __webpack_public_path__ + "static/media/bj.f8d39a7c.svg";